import { GetGreenroomMeetingData } from '@/connection/greenroom/get-greenroom-meeting-data';
import { ProjectStateReducerCreator } from '../types';

const loadGreenroomMeetingReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ sessionUuid, token }: { sessionUuid: string; token: string }, { rejectWithValue }) => {
      if (!token) {
        return rejectWithValue('No ID Token');
      }

      return GetGreenroomMeetingData(sessionUuid);
    },
    {
      fulfilled: (state, action) => {
        state.greenroomMeeting = action.payload;
        state.greenroomMeetingError = false;
      },
      pending: (state) => {
        state.greenroomMeetingLoading = true;
      },
      settled: (state) => {
        state.greenroomMeetingLoading = false;
      },
      rejected: (state, action) => {
        console.error(action);
        state.greenroomMeetingError = true;
      },
    }
  );
};

export default loadGreenroomMeetingReducer;
